import ArticleWrapper from '@/components/ArticleWrapper';

export default function createSightMapSingleView(category, slug) {
  const key = `custom-article-${category}-${slug}`;
  return {
    name: key,
    asyncData({ i18n, store, route }) {
      return Promise.all([
        store.dispatch('article/FETCH_ARTICLE', { 
          category: category,
          slug: slug,
          locale: i18n.locale 
        }),      
      ]);
    },
    components: {
      ArticleWrapper,
    },
    render (h) {
      return h(ArticleWrapper, { props: { category, slug, key }})
    }
  }
}